import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import Login from './Login';

export default function OrgLogin() {
  const { orgSlug } = useParams();
  const [orgData, setOrgData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrg = async () => {
      if (!orgSlug) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${API}/resolve-subdomain/${orgSlug}`);
        setOrgData(response.data);
        
        // Store the organization in sessionStorage
        sessionStorage.setItem('current_org', JSON.stringify(response.data));
        
        // Apply custom branding CSS variables
        if (response.data.primary_color) {
          document.documentElement.style.setProperty('--org-primary', response.data.primary_color);
        }
        if (response.data.secondary_color) {
          document.documentElement.style.setProperty('--org-secondary', response.data.secondary_color);
        }
      } catch (err) {
        console.error('Failed to resolve organization:', err);
        setError('Organization not found');
      } finally {
        setLoading(false);
      }
    };

    fetchOrg();
  }, [orgSlug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#00A3A1] mx-auto"></div>
          <p className="mt-4 text-slate-500">Loading {orgSlug}...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-slate-50 to-[#E6F7F7]/30">
        <div className="text-center bg-white p-8 rounded-xl shadow-lg max-w-md">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center">
            <svg className="w-8 h-8 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-slate-800">Organization Not Found</h1>
          <p className="mt-2 text-slate-600">
            The organization "<span className="font-medium">{orgSlug}</span>" does not exist.
          </p>
          <a 
            href="/" 
            className="mt-6 inline-block px-6 py-2 bg-[#00A3A1] text-white rounded-lg hover:bg-[#008B89] transition-colors"
          >
            Go to Main Site
          </a>
        </div>
      </div>
    );
  }

  // Render Login with organization data
  return <Login orgData={orgData} orgSlug={orgSlug} />;
}
